/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { optional as codecOptional } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseAbout } from './BaseAbout';
import { HealthInformation } from './HealthInformation';
const AboutParser = /* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['health', /* #__PURE__ */ codecOptional(HealthInformation)],
]), BaseAbout);
export class About extends BaseAbout {
    static decode(input) {
        return AboutParser.decode(input).map(res => new About(res));
    }
    static unsafeDecode(input) {
        return About.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AboutParser.encode(data);
    }
    static schema() {
        return AboutParser.schema();
    }
}
